import rawContentfulData from "@/data/contentfulLandingPageBuilder.json";
import { LandingPageBuilder } from "@/types/landingPageBuilder";

// Cast the imported JSON data to the typed array
const contentfulData = rawContentfulData as unknown as LandingPageBuilder[];

/**
 * Normalize slug by removing leading/trailing slashes and ensuring consistent format
 */
const normalizeSlug = (slug: string): string => {
  return slug.replace(/^\/+|\/+$/g, "");
};

/**
 * Get landing page builder data by slug
 * @param slug - The slug of the landing page to retrieve (can be a string or array for catch-all routes)
 * @returns The landing page data object with the matching slug, or undefined if not found or not visible
 */
export const getLandingPageBuilderBySlug = (
  slug: string | string[]
): LandingPageBuilder | undefined => {
  // Handle catch-all routes (array) or single slug (string)
  const slugString = Array.isArray(slug) ? slug.join("/") : slug;
  const normalizedSlug = normalizeSlug(slugString);

  const page = contentfulData.find((item) => {
    const normalizedItemSlug = normalizeSlug(item.slug);
    return normalizedItemSlug === normalizedSlug;
  });

  if (!page) {
    return undefined;
  }
  return page;
};

/**
 * Get all slugs for landing page builder pages
 * @returns Array of all visible landing page slugs (normalized for Next.js route params)
 */
export const getAllLandingPageBuilderSlugs = (): string[] => {
  return contentfulData.map((item) => {
    const normalized = normalizeSlug(item.slug);
    /*
     * For catch-all routes, return as array of segments
     * Next.js will handle the array format
     */
    return normalized;
  });
};
